import { cn } from '@/utils/tailwind.util';
export const AiTutorSprite = ({
  size,
  className
}: {
  size: number;
  className?: string;
}) => {
  return <div className={cn('animate-ai-tutor-sprite overflow-hidden', className)} style={{
    backgroundImage: 'url(/assets/ai-tutor/sprite/ai-tutor.webp)',
    backgroundSize: `${size * 5}px ${size}px`,
    width: `${size}px`,
    height: `${size}px`
  }} data-sentry-component="AiTutorSprite" data-sentry-source-file="AiTutorSprite.tsx" />;
};